import { createElement } from 'react';
import './title-1.scss';
const Title1 = ({ title = '标题标题', ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "custom-title-1", ..._otherProps },
        createElement("span", null, title)));
};
Title1.displayName = 'Title1';
export default Title1;
